import { createApi } from '@reduxjs/toolkit/query/react';
import { IApiResponse, IPaginate } from '../../interfaces/common';
import { IEditHmoPrice, IHmo, IHmoAdmissionList, IHmoApproval, IHmoBill, IHmoBloodList, IHmoClaim, IHmoClaimResponse, IHmoLaboratoryList, IHmoMedicationList, IHmoOtherServiceList, IHmoPatientList, IHmoProcedureList, IHmoProfessionalServiceList, IHmoRadiologyList } from '../../interfaces/hmo';
import { baseQuery } from './common';
import { data } from 'jquery';
import { number, string } from 'yup';

export const hmoApi = createApi({
	reducerPath: 'hmos',
	baseQuery: baseQuery,
	tagTypes: ['Hmos', 'HmoApproval', 'Hmo', 'Template', "AuditTrail"],
	// refetchOnFocus: true,
	// refetchOnMountOrArgChange: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({
		getHmos: builder.query<IApiResponse<IPaginate<IHmo[]>>, { pagination: { page?: number; limit?: number }; searchTerm?: string; status?: string }>({
			query: ({ pagination: { page = 1, limit = 10 }, searchTerm, status }) =>
				`/hmo?page=${page}&limit=${limit}${searchTerm ? `&searchTerm=${searchTerm}` : ''}${status ? `&status=${status}` : ''}`,
			providesTags: [{ type: 'Hmos', id: 'LIST' }],
		}),

		getAllHmos: builder.query<IApiResponse<IPaginate<IHmo[]>>, { status?: string }>({
			query: ({ status }) => `/hmo?limit=10000${status ? `&status=${status}` : ''}`,
			providesTags: [{ type: 'Hmos', id: 'LIST' }],
		}),

		getHmo: builder.query<IApiResponse<IHmo>, string>({
			query: (id) => `/hmo/${id}`,
			providesTags: (result, error, arg) => [{ type: 'Hmo', id: arg }],
		}),

		// Modify the others to follow this format

		getHMOAdmissionList: builder.query<IApiResponse<IPaginate<IHmoAdmissionList[]>>, { id: string; filterBy?: string; pagination: { page?: number; limit?: number }; searchTerm?: string; }>({

			query: ({ id, filterBy, pagination: { page = 1, limit = 10 }, searchTerm, }) =>
				`/hmo/${id}/price-list/Admission?page=${page}&limit=${limit}${filterBy ? `&filterBy=${filterBy}` : ''}${searchTerm ? `&searchTerm=${searchTerm}` : ''}`,
			providesTags: (result, error, arg) => [
				{ type: 'Hmo', id: arg.id }, 'Hmos'],
		}),

		getHMOBloodList: builder.query<IApiResponse<IPaginate<IHmoBloodList[]>>, { id: string; filterBy?: string; pagination: { page?: number; limit?: number }; searchTerm?: string; }>({

			query: ({ id, filterBy, pagination: { page = 1, limit = 10 }, searchTerm, }) =>
				`/hmo/${id}/price-list/Blood?page=${page}&limit=${limit}${filterBy ? `&filterBy=${filterBy}` : ''}${searchTerm ? `&searchTerm=${searchTerm}` : ''}`,
			providesTags: (result, error, arg) => [{ type: 'Hmo', id: arg.id }],
		}),

		getHMOLaboratoryList: builder.query<IApiResponse<IPaginate<IHmoLaboratoryList[]>>, { id: string; filterBy?: string; pagination: { page?: number; limit?: number }; searchTerm?: string; }>({

			query: ({ id, filterBy, pagination: { page = 1, limit = 10 }, searchTerm, }) =>
				`/hmo/${id}/price-list/Laboratory?page=${page}
				&limit=${limit}${filterBy ? `&filterBy=${filterBy}` : ''}${searchTerm ? `&searchTerm=${searchTerm}` : ''}`,
			providesTags: (result, error, arg) => [{ type: 'Hmo', id: arg.id }],
		}),


		getHMORadiologyList: builder.query<IApiResponse<IPaginate<IHmoRadiologyList[]>>, { id: string; filterBy?: string; pagination: { page?: number; limit?: number }; searchTerm?: string; }>({

			query: ({ id, filterBy, pagination: { page = 1, limit = 10 }, searchTerm, }) =>
				`/hmo/${id}/price-list/Radiology?page=${page}
				&limit=${limit}${filterBy ? `&filterBy=${filterBy}` : ''}${searchTerm ? `&searchTerm=${searchTerm}` : ''}`,
			providesTags: (result, error, arg) => [{ type: 'Hmo', id: arg.id }],
		}),

		getHMOMedicationList: builder.query<IApiResponse<IPaginate<IHmoMedicationList[]>>, { id: string; filterBy?: string; pagination: { page?: number; limit?: number }; searchTerm?: string; }>({

			query: ({ id, filterBy, pagination: { page = 1, limit = 10 }, searchTerm, }) =>
				`/hmo/${id}/price-list/Medication?page=${page}
				&limit=${limit}${filterBy ? `&filterBy=${filterBy}` : ''}${searchTerm ? `&searchTerm=${searchTerm}` : ''}`,
			providesTags: (result, error, arg) => [{ type: 'Hmo', id: arg.id }],
		}),

		getHMOProcedureList: builder.query<IApiResponse<IPaginate<IHmoProcedureList[]>>, { id: string; filterBy?: string; pagination: { page?: number; limit?: number }; searchTerm?: string; }>({

			query: ({ id, filterBy, pagination: { page = 1, limit = 10 }, searchTerm, }) =>
				`/hmo/${id}/price-list/Procedure?page=${page}
				&limit=${limit}${filterBy ? `&filterBy=${filterBy}` : ''}${searchTerm ? `&searchTerm=${searchTerm}` : ''}`,
			providesTags: (result, error, arg) => [{ type: 'Hmo', id: arg.id }],
		}),

		getHMOProfessionalServiceList: builder.query<IApiResponse<IPaginate<IHmoProfessionalServiceList[]>>, { id: string; filterBy?: string; pagination: { page?: number; limit?: number }; searchTerm?: string; }>({

			query: ({ id, filterBy, pagination: { page = 1, limit = 10 }, searchTerm, }) =>
				`/hmo/${id}/price-list/ProfessionalService?page=${page}
				&limit=${limit}${filterBy ? `&filterBy=${filterBy}` : ''}${searchTerm ? `&searchTerm=${searchTerm}` : ''}`,
			providesTags: (result, error, arg) => [{ type: 'Hmo', id: arg.id }],
		}),

		getHMOOtherServiceList: builder.query<IApiResponse<IPaginate<IHmoOtherServiceList[]>>, { id: string; filterBy?: string; pagination: { page?: number; limit?: number }; searchTerm?: string; }>({

			query: ({ id, filterBy, pagination: { page = 1, limit = 10 }, searchTerm, }) =>
				`/hmo/${id}/price-list/OtherService?page=${page}
				&limit=${limit}${filterBy ? `&filterBy=${filterBy}` : ''}${searchTerm ? `&searchTerm=${searchTerm}` : ''}`,
			providesTags: (result, error, arg) => [{ type: 'Hmo', id: arg.id }],
		}),

		// View Patient List for one HMO at a time.		
		getHMOPatientList: builder.query<IApiResponse<IPaginate<IHmoPatientList[]>>, { id: string; filterBy?: string; pagination: { page?: number; limit?: number }; searchTerm?: string }>({

			query: ({ id, filterBy, pagination: { page = 1, limit = 10 }, searchTerm }) =>
				`/hmo/${id}/patient?page=${page}&limit=${limit}${searchTerm ? `&searchTerm=${searchTerm}` : ''}${filterBy ? `&status=${filterBy}` : ''}`,
			providesTags: (result, error, arg) => [{ type: 'Hmo', id: arg.id }],
		}),

		getHmoExcelTemplate: builder.query<IApiResponse<{ url: string }>, 'url' | 'file'>({
			query: (type: 'url' | 'file' = 'url') => `/hmo/template/?type=${type}`,
			providesTags: (result, error, arg) => [{ type: 'Template', id: arg }],
		}),
		addHmo: builder.mutation<IHmo, Partial<IHmo>>({
			query: (body) => ({
				url: `hmo`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['Hmos', 'Hmo'],
		}),
		updateHmo: builder.mutation<IHmo, { id: string; data: Partial<IHmo> }>({
			query({ id, data }) {
				return {
					url: `hmo/${id}`,
					method: 'PUT',
					body: data,
				};
			},
			invalidatesTags: (result, error, arg) => [{ type: 'Hmo', id: arg.id }, 'Hmos'],
		}),
		deleteHmo: builder.mutation<IHmo, Partial<IHmo>>({
			query: ({ id }) => ({
				url: `/hmo/${id}`,
				method: 'DELETE',
				body: id,
			}),
			invalidatesTags: ['Hmos', 'Hmo'],
		}),
		generateAdmissionPriceList: builder.mutation<
			IHmo,
			{
				id: string;
			}
		>({
			query({ id }) {
				return {
					url: `/hmo/${id}/price-list/Admission`,
					method: 'POST',
				};
			},
			invalidatesTags: (result, error, arg) => [{ type: 'Hmo', id: arg.id }, 'Hmos'],
		}),
		generateBloodPriceList: builder.mutation<
			IHmo,
			{
				id: string;
			}
		>({
			query({ id }) {
				return {
					url: `/hmo/${id}/price-list/Blood`,
					method: 'POST',
				};
			},
			invalidatesTags: (result, error, arg) => [{ type: 'Hmo', id: arg.id }, 'Hmos'],
		}),
		generateLaboratoryPriceList: builder.mutation<
			IHmo,
			{
				id: string;
			}
		>({
			query({ id }) {
				return {
					url: `/hmo/${id}/price-list/Laboratory`,
					method: 'POST',
				};
			},
			invalidatesTags: (result, error, arg) => [{ type: 'Hmo', id: arg.id }, 'Hmos'],
		}),
		generateRadiologyPriceList: builder.mutation<
			IHmo,
			{
				id: string;
			}
		>({
			query({ id }) {
				return {
					url: `/hmo/${id}/price-list/Radiology`,
					method: 'POST',
				};
			},
			invalidatesTags: (result, error, arg) => [{ type: 'Hmo', id: arg.id }, 'Hmos'],
		}),
		generateMedicationPriceList: builder.mutation<
			IHmo,
			{
				id: string;
			}
		>({
			query({ id }) {
				return {
					url: `/hmo/${id}/price-list/Medication`,
					method: 'POST',
				};
			},
			invalidatesTags: (result, error, arg) => [{ type: 'Hmo', id: arg.id }, 'Hmos'],
		}),
		generateProcedurePriceList: builder.mutation<
			IHmo,
			{
				id: string;
			}
		>({
			query({ id }) {
				return {
					url: `/hmo/${id}/price-list/Procedure`,
					method: 'POST',
				};
			},
			invalidatesTags: (result, error, arg) => [{ type: 'Hmo', id: arg.id }, 'Hmos'],
		}),
		generateProfessionalServicePriceList: builder.mutation<
			IHmo,
			{
				id: string;
			}
		>({
			query({ id }) {
				return {
					url: `/hmo/${id}/price-list/ProfessionalService`,
					method: 'POST',
				};
			},
			invalidatesTags: (result, error, arg) => [{ type: 'Hmo', id: arg.id }, 'Hmos'],
		}),
		generateOtherServicePriceList: builder.mutation<
			IHmo,
			{
				id: string;
			}
		>({
			query({ id }) {
				return {
					url: `/hmo/${id}/price-list/OtherService`,
					method: 'POST',
				};
			},
			invalidatesTags: (result, error, arg) => [{ type: 'Hmo', id: arg.id }, 'Hmos'],
		}),
		completeListGeneration: builder.mutation<
			IHmo,
			{
				id: string;
			}
		>({
			query({ id }) {
				return {
					url: `/hmo/${id}/price-list/complete`,
					method: 'PATCH',
				};
			},
			invalidatesTags: (result, error, arg) => [{ type: 'Hmo', id: arg.id }, 'Hmos'],
		}),
		updateAdmissionPrice: builder.mutation<IHmoAdmissionList, Partial<IHmoAdmissionList>>({
			query(data) {
				const { id, hmoId, ...body } = data;
				return {
					url: `/hmo/${data.hmoId}/price-list/Admission/${data.id}`,
					method: 'PUT',
					body,

				};
			},
			invalidatesTags: (result, error, arg) => [
				{ type: 'Hmo', id: arg.hmoId },
				{ type: 'Hmo', id: arg.id }, 'Hmos'],
		}),
		updateBloodListPrice: builder.mutation<IHmoBloodList, Partial<IHmoBloodList>>({
			query(data) {
				const { id, hmoId, ...body } = data;
				return {
					url: `/hmo/${data.hmoId}/price-list/Blood/${data.id}`,
					method: 'PUT',
					body,

				};
			},
			invalidatesTags: (result, error, arg) => [
				{ type: 'Hmo', id: arg.hmoId },
				{ type: 'Hmo', id: arg.id }, 'Hmos'],
		}),
		updateLaboratoryPrice: builder.mutation<IHmoLaboratoryList, Partial<IHmoLaboratoryList>>({
			query(data) {
				const { id, hmoId, ...body } = data;
				return {
					url: `/hmo/${data.hmoId}/price-list/Laboratory/${data.id}`,
					method: 'PUT',
					body,

				};
			},
			invalidatesTags: (result, error, arg) => [
				{ type: 'Hmo', id: arg.hmoId },
				{ type: 'Hmo', id: arg.id }, 'Hmos'],
		}),
		updateRadiologyPrice: builder.mutation<IHmoRadiologyList, Partial<IHmoRadiologyList>>({
			query(data) {
				const { id, hmoId, ...body } = data;
				return {
					url: `/hmo/${data.hmoId}/price-list/Radiology/${data.id}`,
					method: 'PUT',
					body,

				};
			},
			invalidatesTags: (result, error, arg) => [
				{ type: 'Hmo', id: arg.hmoId },
				{ type: 'Hmo', id: arg.id }, 'Hmos'],
		}),
		updateMedicationPrice: builder.mutation<IHmoMedicationList, Partial<IHmoMedicationList>>({
			query(data) {
				const { id, hmoId, ...body } = data;
				return {
					url: `/hmo/${data.hmoId}/price-list/Medication/${data.id}`,
					method: 'PUT',
					body,

				};
			},
			invalidatesTags: (result, error, arg) => [
				{ type: 'Hmo', id: arg.hmoId },
				{ type: 'Hmo', id: arg.id }, 'Hmos'],
		}),
		updateProcedurePrice: builder.mutation<IHmoProcedureList, Partial<IHmoProcedureList>>({
			query(data) {
				const { id, hmoId, ...body } = data;
				return {
					url: `/hmo/${data.hmoId}/price-list/Procedure/${data.id}`,
					method: 'PUT',
					body,

				};
			},
			invalidatesTags: (result, error, arg) => [
				{ type: 'Hmo', id: arg.hmoId },
				{ type: 'Hmo', id: arg.id }, 'Hmos'],
		}),
		updateProfessionalServicePrice: builder.mutation<IHmoProfessionalServiceList, Partial<IHmoProfessionalServiceList>>({
			query(data) {
				const { id, hmoId, ...body } = data;
				return {
					url: `/hmo/${data.hmoId}/price-list/ProfessionalService/${data.id}`,
					method: 'PUT',
					body,

				};
			},
			invalidatesTags: (result, error, arg) => [
				{ type: 'Hmo', id: arg.hmoId },
				{ type: 'Hmo', id: arg.id }, 'Hmos'],
		}),
		updateOtherServicePrice: builder.mutation<IHmoOtherServiceList, Partial<IHmoOtherServiceList>>({
			query(data) {
				const { id, hmoId, ...body } = data;
				return {
					url: `/hmo/${data.hmoId}/price-list/OtherService/${data.id}`,
					method: 'PUT',
					body,

				};
			},
			invalidatesTags: (result, error, arg) => [
				{ type: 'Hmo', id: arg.hmoId },
				{ type: 'Hmo', id: arg.id }, 'Hmos'],
		}),

		uploadHmoPriceListFile: builder.mutation<IApiResponse<IHmo[]>, { id: string; module: string; data: FormData }>({
			query: ({ id, module, data }) => ({
				url: `/hmo/${id}/price-list/${module}`,
				method: 'PUT',
				body: data,
			}),
		}),
		uploadHmoFile: builder.mutation<IApiResponse<IHmo[]>, { data: FormData }>({
			query: ({ data }) => ({
				url: `/hmo/upload`,
				method: 'POST',
				body: data,
			}),
		}),
		getHmoApproval: builder.query<IApiResponse<IPaginate<IHmoApproval[]>>, { pagination: { page?: number; limit?: number }; searchTerm?: string; status?: string; filterBy?: string; startDate?: string; endDate?: string }>({
			query: ({ pagination: { page = 1, limit = 10 }, searchTerm, status, filterBy, startDate, endDate }) =>
				`/hmo/approval?page=${page}&limit=${limit}${searchTerm ? `&searchTerm=${searchTerm}` : ''}${status ? `&status=${status}` : ''}${filterBy ? `&filterBy=${filterBy}` : ''}${startDate ? `&startDate=${startDate}` : ''}${endDate ? `&endDate=${endDate}` : ''}`,

			providesTags: (result, error, arg) => [{ type: 'HmoApproval', id: 'LIST' }],
		}),

		// ${filterBy ? `&filterBy=${filterBy}` : ''}`,

		approveHmoApproval: builder.mutation<IHmoApproval, Partial<IHmoApproval>>({
			query(body) {
				const { id, ...data } = body;
				return {
					url: `/hmo/approval/${id}/approve`,
					method: 'PATCH',
					body: data,
				};
			},
			invalidatesTags: (result, error, arg) => [{ type: 'HmoApproval', id: 'LIST' }],
		}),

		declineHmoApproval: builder.mutation<IHmoApproval, Partial<IHmoApproval>>({
			query(body) {
				const { id, ...data } = body;
				return {
					url: `/hmo/approval/${id}/decline`,
					method: 'PATCH',
					body: data,
				};
			},
			invalidatesTags: (result, error, arg) => [{ type: 'HmoApproval', id: 'LIST' }],
		}),

		getHmoBill: builder.query<IApiResponse<IPaginate<IHmoBill[]>>, { pagination: { page?: number; limit?: number }; searchTerm?: string; filterBy?: string; minAmount?: number; maxAmount?: number; startDate?: string; endDate?: string }>({
			query: ({ pagination: { page = 1, limit = 10 }, searchTerm, filterBy, minAmount, maxAmount, startDate, endDate }) =>
				`/hmo/bill?page=${page}&limit=${limit}${searchTerm ? `&searchTerm=${searchTerm}` : ''}${minAmount ? `&minAmount=${minAmount}` : ''}${maxAmount ? `&maxAmount=${maxAmount}` : ''}${filterBy ? `&filterBy=${filterBy}` : ''}
			${startDate ? `&startDate=${startDate}` : ''}${endDate ? `&endDate=${endDate}` : ''}`,
			providesTags: (result, error, arg) => [{ type: 'Hmo', id: 'LIST' }],
		}),

		getSingleHmoBill: builder.query<IApiResponse<IHmoBill>, string>({
			query: (id) => `/hmo/bill/${id}`,
			providesTags: (result, error, arg) => [{ type: 'Hmo', id: arg }],
		}),
		addHmoBill: builder.mutation<IHmoBill, Partial<IHmoBill>>({
			query: ({ id, ...body }) => ({
				url: `/hmo/bill/${id}/item`,
				method: 'POST',
				body,
			}),
			invalidatesTags: [{ type: 'Hmo', id: 'LIST' }], // Invalidate the 'LIST' tag
		}),
		generateHmoBillInvoice: builder.mutation<{
			id: string;
			data: {
				itemsIds?: string[];
				creatorId: string;
				creatorName: string;
			};
		}, Partial<{
			id: string;
			data: {
				itemsIds?: string[];
				creatorId: string;
				creatorName: string;
			};
		}>>({
			query({ id, ...data }) {
				return {
					url: `/hmo/bill/${id}/generateInvoice`,
					method: 'PUT',
					body: data,
				};
			},
			invalidatesTags: [{ type: 'Hmo', id: 'LIST' }],
		}),

		getHmoPatients: builder.query<IApiResponse<IPaginate<IHmoPatientList[]>>, { id: string; searchTerm?: string }>({
			query: ({ id }) => `/api/hmo/${id}/patient?limit=10000`,
			providesTags: (result, error, arg) => [{ type: 'Hmo', id: arg.id }],
		}),

		getHmoPatientInvoice: builder.query<IApiResponse<IHmoPatientList[]>, { id: string; }>({
			query: ({ id }) => `/api/hmo/${id}/patient/invoice?limit=10000`,
			providesTags: (result, error, arg) => [{ type: 'Hmo', id: arg.id }],
		}),

		postClaim: builder.mutation<IHmoClaim, Partial<IHmoClaim>>({
			query: (data) => ({
				url: `/hmo/claim`,
				method: 'POST',
				body: data,
			}),
			invalidatesTags: (result, error, arg) => [{ type: 'Hmo', id: 'LIST' }],
		}),

		getClaim: builder.query<IApiResponse<IPaginate<IHmoClaimResponse[]>>, { pagination: { page?: number; limit?: number }; searchTerm?: string; filterBy?: string; minDate?: string; maxDate?: string; status?: string; minAmount?: number; maxAmount?: number }>({
			query: ({ pagination: { page = 1, limit = 10 }, searchTerm, filterBy, minDate, maxDate, status, minAmount, maxAmount }) =>
				`/hmo/claim?page=${page}&limit=${limit}${searchTerm ? `&searchTerm=${searchTerm}` : ''}${filterBy ? `&filterBy=${filterBy}` : ''}
			${minDate ? `&minDate=${minDate}` : ''}${maxDate ? `&maxDate=${maxDate}` : ''}${status ? `&status=${status}` : ''}
			${minAmount ? `&minAmount=${minAmount}` : ''}${maxAmount ? `&maxAmount=${maxAmount}` : ''}`,
			providesTags: (result, error, arg) => [{ type: 'Hmo', id: 'LIST' }],
		}),

		submitClaim: builder.mutation<IHmoClaim, Partial<IHmoClaim>>({
			query: (id) => ({
				url: `/hmo/claim/${id}/submit`,
				method: 'PUT',
				body: id,
			}),
			invalidatesTags: (result, error, arg) => [{ type: 'Hmo', id: 'LIST' }],
		}),
		addpaymentToClaim: builder.mutation<IHmoClaim, { id: string } & Partial<IHmoClaim>>({
			query: ({ id, ...data }) => ({
				url: `/hmo/claim/${id}/add-payment`,
				method: 'POST',
				body: data,
			}),
			invalidatesTags: (result, error, arg) => [{ type: 'Hmo', id: 'LIST' }],
		}),
		addWriteOffToClaim: builder.mutation<IHmoClaim, { id: string; } & Partial<IHmoClaim>>({
			query: ({ id, ...data }) => ({
				url: `/hmo/claim/${id}/write-off`,
				method: 'PUT',
				body: data,
			}),
			invalidatesTags: (result, error, arg) => [{ type: 'Hmo', id: 'LIST' }],
		}),
		getClaimIdPayment: builder.query<IApiResponse<IHmoClaimResponse[]>, { id: string }>({
			query: ({ id }) => `/hmo/claim/${id}/payment`,
			providesTags: (result, error, arg) => [{ type: 'Hmo', id: arg.id }],
		}),
		getClaimInfoById: builder.query<IApiResponse<IHmoClaimResponse>, { id: string }>({
			query: ({ id }) => `/hmo/claim/${id}`,
			providesTags: (result, error, arg) => [{ type: 'Hmo', id: arg.id }],
		}),
		getClaimIdPaymentIdInvoice: builder.query<IApiResponse<IHmoClaimResponse[]>, { id: string; }>({
			query: ({ id }) => `/hmo/claim/{id}/payment/${id}/invoice`,
			providesTags: (result, error, arg) => [{ type: 'Hmo', id: arg.id }]
		}),
		// getAuditTrails: builder.query<IApiResponse<IPaginate<any[]>>, { pagination: { page?: number; limit?: number }; search?: string; entityType?: string; startDate?: string; endDate?: string; }>({
		// 	query: ({ pagination: { page = 1, limit = 10 }, search = '', entityType = '', startDate = "", endDate= "" }) =>
		// 		`/audit-trail?page=${page}&limit=${limit}${search ? `&search=${search}` : ''}${entityType ? `&entityType=${entityType}` : ''}
		// 	${startDate ? `&startDate=${startDate}` : ''}${endDate ? `&endDate=${endDate}` : ''}`,
		// 	providesTags: (result, error, arg) => [{ type: 'AuditTrail', id: 'LIST' }],
		// }),
	}),
});

export const {
	// useGetAuditTrailsQuery,
	useGetHmoPatientInvoiceQuery,
	useGetHmoPatientsQuery,
	useGenerateHmoBillInvoiceMutation,
	useGetHmoApprovalQuery,
	useApproveHmoApprovalMutation,
	useDeclineHmoApprovalMutation,
	useGetHmoBillQuery,
	useGetSingleHmoBillQuery,
	useAddHmoBillMutation,
	useGetHmosQuery,
	useGetHmoExcelTemplateQuery,
	useGetHmoQuery,
	useAddHmoMutation,
	useUpdateHmoMutation,
	useDeleteHmoMutation,
	useGetAllHmosQuery,
	useGetHMOAdmissionListQuery,
	useGetHMOBloodListQuery,
	useGetHMOLaboratoryListQuery,
	useGetHMORadiologyListQuery,
	useGetHMOMedicationListQuery,
	useGetHMOProcedureListQuery,
	useGetHMOProfessionalServiceListQuery,
	useGetHMOOtherServiceListQuery,
	useGetHMOPatientListQuery,
	useGenerateAdmissionPriceListMutation,
	useGenerateBloodPriceListMutation,
	useGenerateLaboratoryPriceListMutation,
	useGenerateRadiologyPriceListMutation,
	useGenerateMedicationPriceListMutation,
	useGenerateProcedurePriceListMutation,
	useGenerateProfessionalServicePriceListMutation,
	useGenerateOtherServicePriceListMutation,
	useCompleteListGenerationMutation,
	useUpdateAdmissionPriceMutation,
	useUpdateBloodListPriceMutation,
	useUpdateLaboratoryPriceMutation,
	useUpdateRadiologyPriceMutation,
	useUpdateMedicationPriceMutation,
	useUpdateProcedurePriceMutation,
	useUpdateProfessionalServicePriceMutation,
	useUpdateOtherServicePriceMutation,
	useUploadHmoPriceListFileMutation,
	useUploadHmoFileMutation,
	usePostClaimMutation,
	useGetClaimQuery,
	useSubmitClaimMutation,
	useAddpaymentToClaimMutation,
	useAddWriteOffToClaimMutation,
	useGetClaimIdPaymentQuery,
	useGetClaimInfoByIdQuery,
	useGetClaimIdPaymentIdInvoiceQuery,
} = hmoApi;
